module.exports = __webpack_public_path__ + "img/Colombia.8e709b82.png";